module.exports = __webpack_public_path__ + "img/cargo-wagon-shadow-1.d4a1fefc.png";